import { create } from "zustand";

const MainStore = create((set) => ({
  firstLoad: false,
  setFirstLoad: (bol) => {
    set((state) => {
      return { firstLoad: bol };
    });
  },
  detailedView: null,
  setDetailedView: (object) =>
    set((state) => {
      return { detailedView: object };
    }),
  create: null,
  setCreate: (create) => {
    set((state) => {
      return { create };
    });
  },
  displayedOptions: [],
  setDisplayedOptions: (options) => {
    set((state) => {
      return { displayedOptions: options };
    });
  },
  addDisplayedOption: (option) => {
    set((state) => {
      return { displayedOptions: [...state.displayedOptions, option] };
    });
  },
  removeDisplayedOption: (field, value) => {
    set((state) => {
      const filtered = state.filter((o) => o[field] != value);
      return { displayedOptions: filtered };
    });
  },
  dragCursor: null,
  setDragCursor: (dragCursor) => {
    set((state) => {
      return { dragCursor };
    });
  },
  pointCursor: null,
  setPointCursor: (pointCursor) => {
    set((state) => {
      return { pointCursor };
    });
  },
  displayedBoxes: [],
  addBoxToDisplay: (box) => {
    set((state) => {
      return { displayedBoxes: [...state.displayedBoxes, box] };
    });
  },
  setDisplayedBoxes: (boxes) => {
    set((state) => {
      return { displayedBoxes: boxes };
    });
  },
  verifiedId: null,
  setVerifiedId: (id) => {
    set((state) => {
      return { verifiedId: id };
    });
  },
  setActiveGoal: (goal) => {
    set((state) => {
      const newPlayer = {
        ...state.player,
        active: { ...state.player.active, goal },
      };
      return { player: newPlayer };
    });
  },
  player: null,
  setPlayer: (player) => {
    set((state) => {
      return { player };
    });
  },
  selectedPlayer: null,
  setSelectedPlayer: (player) => {
    set((state) => {
      return { selectedPlayer: player };
    });
  },
  modalOpen: false,
  closeModal: () => {
    set(() => {
      return { modalOpen: false };
    });
  },
  openModal: () => {
    set(() => {
      return { modalOpen: true };
    });
  },
  hideCursor: false,
  setHideCursor: (bol) => {
    set((state) => {
      return { hideCursor: bol };
    });
  },
  tick: 0,
  setTick: (tick) => {
    set((state) => {
      return { tick };
    });
  },
}));

export default MainStore;
